import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { generateUniqueAdminId } from '../../core/helpers/utils';

@Component({
  selector: 'rosie-pills',
  template: `
    <div class="pills-selection-wrapper" [ngClass]="{'auto-width': autoWidth, 'more-than-three': options?.length > 3}">
      <div *ngFor="let option of options; let last = last;" class="pill" (click)="updateValue(option.value)"  [ngClass]="{'selected': isSelected(option.value) || initialValue === option.label}">
        <svg *ngIf="option.iconShape === 'diamond'" class="pill-icon" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.0213 4.12751C5.11988 4.00916 5.24317 3.914 5.38252 3.84868C5.52184 3.78338 5.6738 3.74949 5.82765 3.74941H12.1723C12.3263 3.74949 12.4783 3.78338 12.6176 3.84868C12.7569 3.914 12.8802 4.00916 12.9787 4.12741L15.8593 7.58408C16.0271 7.78543 16.1136 8.0422 16.1018 8.304C16.0899 8.56581 15.9806 8.81371 15.7953 8.99901L9.7424 15.0519C9.5455 15.2487 9.27848 15.3593 9.00005 15.3593C8.72163 15.3593 8.45461 15.2487 8.2577 15.0519L2.20484 8.99903C2.01934 8.81368 1.90992 8.56581 1.89797 8.30401C1.88602 8.04223 1.97239 7.78545 2.1401 7.58411L5.0213 4.12751ZM15.3004 8.5042L15.8979 7.90671H15.053H2.94715H2.10218L2.69967 8.5042L8.75257 14.5571L9.00005 14.8046L9.24754 14.5571L15.3004 8.5042Z"/>
        </svg>
        <img *ngIf="!option.iconShape && option.iconUrl" [src]="option.iconUrl" alt="" class="pill-icon" />
        {{ option.label | translate}}
      </div>
    </div>
  `,
  styleUrls: ['./pills.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PillsComponent {
  form: FormGroup;

  @Input() id = generateUniqueAdminId();
  @Input() customClass: string;
  @Input() title = '';
  @Input() options: PillOption[] | [] | any = [];
  @Input() control: UntypedFormControl | AbstractControl;
  @Input() dataHook = 'radio-group';
  @Input() autoWidth: boolean = false;
  @Output() valueChanged: EventEmitter<string | number> = new EventEmitter<string | number>();

  constructor() {
  }

  get initialValue(): string | number {
    return this.control?.value || this.options[0]?.value;
  }

  updateValue(value: string | number) {
    if (this.control) {
      this.control.setValue(value);
      this.control.markAsDirty();
      this.valueChanged?.emit(value);
    }
  }

  isSelected(value: string | number): boolean {
    return this.control ? value === this.control.value : false;
  }
}

export interface PillOption {
  label: string;
  value: string;
  description?: string;
  iconUrl?: string;
  iconShape?: 'diamond';
}

